export class EntityProperty {
  code: string;
  name?: string;
  value: string;
}
